import env from './env';

export const fetchCustomerVouchers = async (token, customer_id) => {
  return await fetch(
    env('REACT_APP_BACKEND_URL') + '/v3/quota/customers/' + customer_id + '/vouchers',
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    },
  )
    .then((response) => {
      // 200
      if (response.ok) {
        return response.json();
      }
      // ?
      throw response.json();
    })
    .catch((error) => {
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const queueVoucher = async (token, customer_id, voucher) => {
  return await fetch(
    env('REACT_APP_BACKEND_URL') + '/v3/quota/customers/' + customer_id + '/vouchers',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(voucher),
    },
  )
    .then((response) => {
      // 200
      if (response.ok) {
        return response.json();
      }
      // 404 | 409 | 422
      throw response.json();
    })
    .catch((error) => {
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const releaseVoucher = async (token, customer_id, voucher) => {
  return await fetch(
    env('REACT_APP_BACKEND_URL') + '/v3/quota/customers/' + customer_id + '/vouchers',
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(voucher),
    },
  )
    .then((response) => {
      // 200
      if (response.ok) {
        return response.json();
      }
      // 403 | 404 | 409 | 422
      throw response.json();
    })
    .catch((error) => {
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const activateVoucher = async (token, voucher, customer_id) => {
  return await fetch(
    env('REACT_APP_BACKEND_URL') + '/v3/quota/vouchers/activate?customer_id=' + customer_id,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(voucher),
    },
  )
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      // 403 | 404 | 409 | 422
      throw response.json();
    })
    .catch((error) => {
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const downloadVouchers = async (token, vouchers, format, customer_id) => {
  return await fetch(
    env('REACT_APP_BACKEND_URL') + '/v3/quota/vouchers/' + format + '?customer_id=' + customer_id,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(vouchers),
    },
  )
    .then((response) => {
      if (response.ok) {
        return response.blob();
      }
      // 404 | 422
      throw response.json();
    })
    .then((blob) => {
      return window.URL.createObjectURL(blob);
    })
    .catch((error) => {
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const mailVouchers = async (token, postData, customer_id) => {
  return await fetch(
    env('REACT_APP_BACKEND_URL') + '/v3/quota/vouchers/mail' + '?customer_id=' + customer_id,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify(postData),
    },
  )
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      // 404 | 422
      throw response.json();
    })
    .catch((error) => {
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};
